import Link from 'next/link';
import Head from 'next/head';
import { PaasNavigationCode } from '@/components/codeHighlights/PaasNavigationCode';
import { PaasHeaderCode } from '@/components/codeHighlights/PaasHeaderCode';

const Page = () => {
  return (
    <>
      <Head>
        <title>Webdienst-Header</title>
      </Head>
      <h1>Webdienst-Header</h1>
      <p className="lead">
        Der Webdienst-Header wird in erster Linie für Microsites verwendet.
        Weitere Erläuterungen sind auf der Seite{' '}
        <Link href={`/corporate-design/webdienste`} legacyBehavior>
          <a>Webdienste</a>
        </Link>{' '}
        dokumentiert.
      </p>
      <div className="mt-5">
        <PaasHeaderCode />
      </div>
      <div className="mt-5">
        <PaasNavigationCode />
      </div>
    </>
  );
};

export default Page;
